import { AbortController as AbortControllerPolyfill } from './AbortController';
const g = typeof self !== 'undefined' ? self : global;
export const AbortController = g.AbortController
    ? g.AbortController
    : AbortControllerPolyfill;

//# sourceMappingURL=AbortController.ponyfill.js.map
